import classNames from 'classnames';
import React, { useState } from 'react';
import Dropdown from 'layout/atoms/Dropdown/Dropdown';
import styles from './AvatarsList.module.scss';
const VISIBLE_WHEN_OVERFLOWING = 3;
function getAvatarLabel(child) {
    var _a;
    if (React.isValidElement(child) &&
        typeof ((_a = child.props) === null || _a === void 0 ? void 0 : _a.userName) === 'string') {
        return child.props.userName;
    }
    return undefined;
}
// GitHub-style avatar stack: overlapping by default, spreads apart on hover
// so every avatar becomes fully visible. Beyond `max` avatars, only the first
// few show — the rest collapse into a "+N" bubble, on the left of the stack,
// that opens a dropdown listing the rest.
function AvatarsList({ children, max = 4, avatarSize = 'm' }) {
    const [isOverflowMenuOpen, setIsOverflowMenuOpen] = useState(false);
    const items = React.Children.toArray(children);
    const isOverflowing = items.length > max;
    const visibleItems = isOverflowing ? items.slice(0, VISIBLE_WHEN_OVERFLOWING) : items;
    const hiddenItems = isOverflowing ? items.slice(VISIBLE_WHEN_OVERFLOWING) : [];
    // Leftmost sits on top, each one further right sits behind the previous —
    // the opposite of plain DOM order, which would stack later (righter) items
    // on top — so this needs an explicit, descending z-index.
    return (React.createElement("div", { className: styles.wrap, onMouseLeave: () => setIsOverflowMenuOpen(false) },
        isOverflowing && (React.createElement("div", { className: styles.item, style: { zIndex: visibleItems.length + 1 } },
            React.createElement(Dropdown, { controlled: true, open: isOverflowMenuOpen, onClose: () => setIsOverflowMenuOpen(false), trigger: React.createElement("div", { role: "button", tabIndex: 0, className: classNames(styles.overflow, styles[avatarSize]), onClick: () => setIsOverflowMenuOpen((prev) => !prev), onKeyDown: (e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            setIsOverflowMenuOpen((prev) => !prev);
                        }
                    } },
                    React.createElement("p", null,
                        "+",
                        hiddenItems.length)) }, hiddenItems.map((child, index) => (React.createElement("div", { key: index, className: styles.hiddenItem },
                child,
                getAvatarLabel(child) && React.createElement("span", null, getAvatarLabel(child)))))))),
        visibleItems.map((child, index) => (React.createElement("div", { key: index, className: styles.item, style: { zIndex: visibleItems.length - index } }, child)))));
}
export default AvatarsList;
